import Velocity from 'velocity-animate';
const hamburgerMenu = {

    init() {
        var McButton = $("[data=hamburger-menu]");
        var McBar1 = McButton.find("span:nth-child(1)");
        var McBar2 = McButton.find("span:nth-child(2)");
        var McBar3 = McButton.find("span:nth-child(3)");

        var menuItem = $('.js-burger-menu-target');



        McButton.click( function() {
            $(this).toggleClass("active");
            menuItem.toggleClass('active');
            $('body').toggleClass('menu-open')
            if (McButton.hasClass("active")) {
               Velocity( McBar1, { top: "50%" }, {duration: 200, easing: "swing"});
               Velocity(McBar3, { top: "50%" }, {duration: 200, easing: "swing"});
               Velocity(McBar3,{rotateZ:"90deg"}, {duration: 800, delay: 200, easing: [500,20] });
               Velocity(McButton, {rotateZ:"135deg"}, {duration: 800, delay: 200, easing: [500,20] });

               // Velocity(menuItem, {translateX:"0%"}, {duration: 1200, delay: 200, easing: "swing"});

            } else {
                Velocity(McButton, "reverse");
                Velocity(McBar3, {rotateZ:"0deg"}, {duration: 800, easing: [500,20] })
                Velocity(McBar3, { top: "100%" }, {duration: 200, easing: "swing"});
                Velocity(McBar1, "reverse", {delay: 800});
            }
        });




        /*$element.Velocity({
            width: "500px",
            property2: value2
        }, {
            duration: 400,
            easing: "swing",
            queue: "",
            begin: undefined,
            progress: undefined,
            complete: undefined,
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: false,
            mobileHA: true
        });*/
    }
}

export {hamburgerMenu}